import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import AvatarGroup from '@mui/material/AvatarGroup';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Pagination from '@mui/material/Pagination';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import NavigateNextRoundedIcon from '@mui/icons-material/NavigateNextRounded';

const articleInfo = [
  {
    tag: 'Engineering/Semiconductor Failure Analysis',
    title: 'Soft Defects: Challenge and Chance for Failure Analysis',
    link: 'https://ieeexplore.ieee.org/document/4378091',
    date:'2007',
    description:
      'Failure analysis on advanced logic and mixed signal ICs more and more has to deal with so called "soft defects". In this paper, an analysis flow especially for parameter dependent scan fails is presented. For the two major localization techniques, namely soft defect localization (SDL) and internal signal measurement enhanced activation and localization procedures using test systems are proposed',
    authors: [
      { name: 'Christian Burmer', avatar: '/static/images/avatar/1.jpg' },
      { name: 'Christof Brillert', avatar: '/static/images/avatar/2.jpg' },
      { name: 'Zhongling Qian', avatar: '/static/images/avatar/2.jpg' },
    ],
  },
  {
    tag: 'Engineering/Semiconductor Failure Analysis',
    title: 'Software aided failure analysis using ATPG tool',
    link: 'https://ieeexplore.ieee.org/document/941488/',
    date:'2001',
    description:
      'Automatic test pattern generation (ATPG) is recommended in order to obtain high test coverage quickly. For failure analysis, some standard ATPG tools offer in addition a feature to perform fault diagnosis on full scan designs. Software fault localization techniques become increasingly important in future designs, since in highly complex VHDL programmed designs, a standard analysis using functional test vectors is expendable and time consuming. This paper describes all steps necessary for project set-up and a flow for fault diagnosis. In order to minimize the list of possible failures (given by the tool) and to determine the physical location of the defect (x,y,z), a failure localization flow is presented. Initial results on ICs with both failures purposely induced by focused ion beam and real production failures represents an excellent starting point for further fault localization.',
    authors: [{ name: 'Peter Egger', avatar: '/static/images/avatar/6.jpg' },
       { name: 'Christian Burmer', avatar: '/static/images/avatar/1.jpg' },
    ],
  },

{
    tag: 'Engineering/Semiconductor Failure Analysis',
    title: 'Statistical  aided failure analysis using ATPG tool',
    link: 'https://www.researchgate.net/publication/348106719_Statistical_Evaluation_of_Scan_Test_Diagnosis_Results_for_Yield_Enhancement_of_Logic_Designs',
    date:'2005',
    description:
    'During yield ramp, quick turnaround times between production failures and the results of physical failure analysis are essential. In spite of the growing complexity of today\'s logic designs, a fast defect localization can be done by using diagnostic features implemented within standard test pattern generation tools. The diagnosis result can not only be used for fault localization but also for statistical analysis based on a large number of failing chips. This statistical approach enables the search for systematic yield detractors and leads to a faster product or technology ramp. This paper describes the necessary steps in order to set up statistical scan diagnosis, discusses the main failure analysis strategies and gives experimental results.',
      authors: [
       { name: 'Christian Burmer', avatar: '/static/images/avatar/1.jpg' },
       { name: 'Hans-Peter Erb', avatar: '/static/images/avatar/6.jpg' },
       { name: 'Andreas Leininger', avatar: '/static/images/avatar/6.jpg' },
       { name: 'Markus Gruetzner', avatar: '/static/images/avatar/6.jpg' },
    ],
  },

  {
    tag: 'Engineering/Semiconductor Failure Analysis',
    title: 'Tester Assisted Multiple Emission Microscopy',
    link: 'https://www.researchgate.net/publication/347827004_Tester_Assisted_Multiple_Emission_Microscopy',
    date:'2015',
    description:
      'Multiple emission microscopy can be used to obtain a comprehensive overview of device emission during IDDQ-test. In this new approach an emission microscopy image is taken for each pattern of the IDDQ-test. Then the extensive amount of images is analyzed for correlation with IDDQ current levels. As a result, for each increased current level concurrent spots can be identified and further analyzed.',
    authors: [{ name: 'Christian Hollerith', avatar: '/static/images/avatar/6.jpg' },
      { name: 'Gerhard Borgmann', avatar: '/static/images/avatar/6.jpg' },
      { name: 'Wolfgang Schaller', avatar: '/static/images/avatar/6.jpg' },
       { name: 'Christian Burmer', avatar: '/static/images/avatar/1.jpg' },
    ],
  },
  {
    tag: 'Engineering/Semiconductor Failure Analysis',
    title: 'Improved Parasitic Fault Modeling for Automatic Analog Fault Simulation',
    link: 'https://www.researchgate.net/publication/266137837_Improved_Parasitic_Fault_Modeling_for_Automatic_Analog_Fault_Simulation',
    date:'2012',
    description:
      'Analog simulation combined with Time Resolved Light Emission (TRE) can be used to evaluate different fault possibilities and to isolate the most likely fault candidate. In this paper we will describe an improved fault model derived from parasitic layout extraction.',
    authors: [
      { name: 'Gerhard Borgmann', avatar: '/static/images/avatar/6.jpg' },
      { name: 'Sébastien Mézière', avatar: '/static/images/avatar/6.jpg' },
       { name: 'Christian Burmer', avatar: '/static/images/avatar/1.jpg' },
    ],
  },
  {
    tag: 'Engineering/Semiconductor Failure Analysis',
    title: 'Improved Lock-in Phase Mapping of Modulated Reflectance with SIL',
    link: 'https://www.researchgate.net/publication/347831096_Improved_Lock-in_Phase_Mapping_of_Modulated_Reflectance_with_SIL',
    date:'2014',
    description:
      'The application of lockin phase mapping of modulated reflectance with SIL is discussed in detail, particularly the socalled ghost mapping signal in STI neighboring to active regions. The different lockin phase between active regions and ghost regions showed clearly that both of them have different physical origins. The phase transition between active regions provides an enhancement of spatial resolution for defect localization in scan cell and sub blocks.',
    authors: [
      { name: 'Zhongling Qian', avatar: '/static/images/avatar/6.jpg' },
      { name: 'Christof Brillert', avatar: '/static/images/avatar/6.jpg' },
       { name: 'Christian Burmer', avatar: '/static/images/avatar/1.jpg' },
    ],
  },
  
  {
    tag: 'Engineering/Semiconductor Failure Analysis',
    title: 'Ultra-fast CAD scan chain highlighting for failure analysis assistance',
    link: 'Ultra-fast CAD scan chain highlighting for failure analysis assistance',
    date:'2010',
    description:
      'Automatic test pattern generation (ATPG) and scan tests are common design for testability methods (DfT) for digital logic ICs. A prerequisite for structural logic tests is the integrity of the embedded test circuit itself, i.e. the scan flipflops that are stringed together in scan chains. If there is a failure within one of the scan chains, localization can be quite challenging. One particular problem for failure analysis engineers is the CAD navigation along the chain: in order to display the physical position of a scan chain, hundreds or even thousands of flipflops have to be cross-mapped between the design netlist and the physical layout. This task requires extensive computing and can be very time-consuming. The work described in this paper is a new data processing method that reduces the required computing time from several hours down to a few seconds.',
    authors: [
      { name: 'Markus Gruetzner', avatar: '/static/images/avatar/6.jpg' },
      { name: 'Christof Brillert', avatar: '/static/images/avatar/6.jpg' },
       { name: 'Christian Burmer', avatar: '/static/images/avatar/1.jpg' },
    ],
  },
  {
    tag: 'Engineering/Semiconductor Failure Analysis',
    title: 'Advanced Dynamic Laser-Stimulation Methods Using Lock-In and Mixed-Frequency Techniques',
    link: 'https://www.researchgate.net/publication/290575428_Advanced_dynamic_laser-stimulation_methods_using_lock-in_and_mixed-frequency_techniques',
    date:'2010',
    description:
      'MF-TLS (Mixed-Frequency-Thermal laser stimulation), as an extension of current-mode lock-in techniques has been developed to facilitate direct detection of open fails. The method has been successfully applied for localization of breaks in scan chains. There are two types of lock-in-assisted TLS techniques. A pulsed laser is applied to the device in the first method, and the response signal is filtered with respect to the modulation frequency of the laser. The second type uses a periodic signal on the chip instead of laser modulation. The second type of lock-in-assisted TLS technique can have lock-in-voltage and -current modes according to the detection parameters. This technique facilitates successful localization without the requirement for direct access to the chips output signals. Also, a spectral-sensitivity technique for advanced analog parameter mapping is shown by means of a GHz-PLL locking problem.',
    authors: [
      { name: 'Zhongling Qian', avatar: '/static/images/avatar/6.jpg' },
      { name: 'Christof Brillert', avatar: '/static/images/avatar/6.jpg' },
       { name: 'Christian Burmer', avatar: '/static/images/avatar/1.jpg' },
    ],
  },
  {
    tag: 'Engineering/Semiconductor Failure Analysis',
    title: 'Combining Time Resolved Emission and Analog Simulation for Fault Localization',
    link: 'https://www.researchgate.net/publication/266137613_Combining_Time_Resolved_Emission_and_Analog_Simulation_for_Fault_Localization',
    date:'2010',
    description:
      'In this paper, we describe a fault localization strategy for scan designs based on Time Resolved Photon Emission (TRE) and analog simulation. After characterizing the defect\'s electrical footprint using TRE, analog fault simulation is applied. A user - friendly software package with an easy to use interface to scan diagnosis, layout tool and simulator was created',
    authors: [
       { name: 'Christian Burmer', avatar: '/static/images/avatar/1.jpg' },
      { name: 'Fabian Hopsch', avatar: '/static/images/avatar/6.jpg' },
      { name: 'Wolfgang Vermeiren', avatar: '/static/images/avatar/6.jpg' },
    ],
  },
  {
    tag: 'Engineering/Semiconductor Failure Analysis',
    title: 'Timing Failure Debug Using Debug-Friendly Scan Patterns and TRE',
    link: 'https://dl.asminternational.org/istfa/proceedings-abstract/ISTFA2008/30910/383/11383',
    date:'2008',
    description:
      'In this paper, we describe a silicon debug flow that uses debug-friendly scan test patterns to improve the efficiency of physical fault isolation of timing failures using time-resolved emission (TRE) system. Several techniques have been developed to generate the debug-friendly test patterns. We further show a silicon debug case of a 90nm design based on the proposed debug flow.',
    authors: [ {name: 'Christian Burmer', avatar: '/static/images/avatar/1.jpg' },
      { name: 'Ruifeng Guo', avatar: '/static/images/avatar/6.jpg' },
      { name: 'Wu-Tung Cheng', avatar: '/static/images/avatar/6.jpg' },
       { name: 'Xijiang Lin', avatar: '/static/images/avatar/1.jpg' },
    ],
  },

  {
    tag: 'Engineering/Semiconductor Failure Analysis',
    title: 'Mixed Frequency Detection of Thermal Laser Stimulation and its Application in Failure Analysis',
    link: 'https://www.researchgate.net/publication/263965368_Mixed_Frequency_Detection_of_Thermal_Laser_Stimulation_and_its_Application_in_Failure_Analysis',
    date:'2008',
    description:
    'A new localization method called MF-TLS is introduced and applied in failure analysis practice. The method combines local periodic thermal stimulation technique with periodic excitation of the electrical fails. The mixed frequency signal is detected by a lock-in amplifier. MF-TLS was demonstrated on fabricated opens in a metal line and shown to be in semi-quantitative agreement with a capacitance modulation model. The technique was also applied to a scan shift problem and produced a higher sensitivity compared with other dynamic TLS methods. Limits and prospects of this new methodology are described.',
      authors: [ {name: 'Christian Burmer', avatar: '/static/images/avatar/1.jpg' },
      { name: 'Zhongling Qian', avatar: '/static/images/avatar/6.jpg' },
      { name: 'Christof Brillert', avatar: '/static/images/avatar/6.jpg' },
       { name: 'Christian Burmer', avatar: '/static/images/avatar/1.jpg' },
    ],
  },


  
  {
    tag: 'Engineering/Semiconductor Failure Analysis',
    title: 'PLL soft functional failure analysis in advanced logic product using fault based analogue simulation and soft defect localization',
    link: 'https://www.researchgate.net/publication/223261114_PLL_soft_functional_failure_analysis_in_advanced_logic_product_using_fault_based_analogue_simulation_and_soft_defect_localization',
    date:'2008',
    description:
    'Soft defect localization (SDL) is an analysis technique where changes in the pass/fail condition of a test are monitored while a laser is scanned across the device under test (DUT). This technique has proven its usefulness for quickly locating defects that are temperature, frequency, and/or voltage dependant, for example, scan logic soft fault. However, due to high sensibility at analogue circuits SDL meets great challenges. This work gives a new flow to analyze soft functional failure in advanced logic products using fault based analogue simulation and SDL. The paper will present one case study illustrating the application of analogue simulation based soft defect localization flow as an effective means to achieve fault isolation.',
      authors: [ {name: 'Christian Burmer', avatar: '/static/images/avatar/1.jpg' },
       { name: 'Liming Gao', avatar: '/static/images/avatar/1.jpg' },
    ],
  },

   {
    tag: 'Engineering/Semiconductor Failure Analysis',
    title: 'Recognizing Named Entities in Failure Analysis Reports',
    link: 'https://ieeexplore.ieee.org/document/10249158/',
    date:'2023',
    description:
      'Failure Analysis (FA) is a complex laboratory activity that requires systematic documentation of all findings and conclusions obtained during an analysis to preserve knowledge acquired by engineers in this process. Current FA information systems store this data in different formats distributed across databases, file shares, wikis, or other human-readable forms. Given a large volume of generated FA data, navigating or searching for particular information is hard since machines cannot automatically process the stored knowledge and require frequent interaction with experts. This paper investigates two applications of modern Natural Language Processing (NLP) approaches to the Named Entity Recognition (NER) task. In particular, we study the performance of two techniques, spaCy, a highly regarded Python library, and the state-of-the-art BERT Language Models (LM), pretrained on semiconductors data. Our experiments show that spaCy reached precision, recall, and F1 scores of about 23%, whereas a BERT-based model achieved a precision of 51%, recall of 49%, and an F1 score of 50% on the test corpus.',
    authors: [{ name: 'Corinna Grabner', avatar: '/static/images/avatar/6.jpg' },
      { name: 'Anna Safont-Andreu', avatar: '/static/images/avatar/6.jpg' },
      { name: 'Christian Hollerith', avatar: '/static/images/avatar/6.jpg' },
      { name: 'Konstantin Schekotihin', avatar: '/static/images/avatar/6.jpg' },
       { name: 'Christian Burmer', avatar: '/static/images/avatar/1.jpg' },
    ],
  },
  
   {
    tag: 'Engineering/Semiconductor Failure Analysis',
    title: 'Towards an FA ChatBot with Retrieval-Augmented Language Modeling',
    link: 'https://www.researchgate.net/publication/384556634_Towards_an_FA_ChatBot_with_Retrieval-Augmented_Language_Modeling',
    date:'2024',
    description:
      'Failure Analysis (FA) data storages, like databases or file shares, host a lot of textual data comprising important information about products, best practices, or past cases. FA engineers require this information at their fingertips to accomplish their tasks efficiently. However, common keyword search interfaces provided by most information systems and databases are insufficient as they force an engineer to formulate a correct query, read returned documents, and manually extract required knowledge from them. In this paper, we suggest a cost-effective approach that augments retrieval systems with the capabilities of modern Large Language Models (LLMs) to provide straight-to-point answers to engineers’ questions. Preliminary evaluation shows that the suggested system can generate high-quality responses to a set of simple benchmark queries but also lacks complex reasoning capabilities for answering complex queries.',
    authors: [{ name: 'Corinna Grabner', avatar: '/static/images/avatar/6.jpg' },
      { name: 'Anna Safont-Andreu', avatar: '/static/images/avatar/6.jpg' },
      { name: 'Christian Hollerith', avatar: '/static/images/avatar/6.jpg' },
      { name: 'Konstantin Schekotihin', avatar: '/static/images/avatar/6.jpg' },
       { name: 'Christian Burmer', avatar: '/static/images/avatar/1.jpg' },
    ],
  },
  {
    tag: 'Engineering/Semiconductor Failure Analysis',
    title: 'Using Ontologies in Failure Analysis',
    link: 'https://dl.asminternational.org/istfa/proceedings-abstract/ISTFA2021/84215/23/18243',
    date:'2021',
    description:
      'Fault analysis is a complex task that requires engineers to perform various analyses to detect and localize physical defects in semiconductor devices. The process is knowledge intensive and must be precisely documented. In order to ensure unambiguous documentation, engineers must agree on a clearly defined terminology specifying methods, tools, physical faults and their electrical signatures among other things, and it must be stored in a way that is usable for both engineers and software. One possible solution to this challenge is to formalize domain knowledge as an ontology, a knowledge base designed to store terminological definitions. This paper discusses the development of an ontology for electronic device failure analysis that uses a logic-based representation. The latter ensures that terms are interpreted the same way by engineers and software systems, facilitating the automation of tasks such as text classification, information retrieval, and workflow verification.',
    authors: [{ name: 'Corinna Grabner', avatar: '/static/images/avatar/6.jpg' },
      { name: 'Anna Safont-Andreu', avatar: '/static/images/avatar/6.jpg' },
      { name: 'Christian Hollerith', avatar: '/static/images/avatar/6.jpg' },
      { name: 'Konstantin Schekotihin', avatar: '/static/images/avatar/6.jpg' },
       { name: 'Christian Burmer', avatar: '/static/images/avatar/1.jpg' },
    ],
  },
  {
    tag: 'Engineering/Semiconductor Failure Analysis',
    title: 'Intelligent Assistants for the Semiconductor Failure Analysis with LLM-Based Planning Agents',
    link: 'https://arxiv.org/pdf/2506.15567',
    date:'2025',
    description:
      'Failure Analysis (FA) is a highly intricate and knowledge-intensive process. The integration of AI components within the computational infrastructure of FA labs has the potential to automate a variety of tasks, including the detection of non-conformities in images, the retrieval of analogous cases from diverse data sources, and the generation of reports from annotated images. However, as the number of deployed AI models increases, the challenge lies in orchestrating these components into cohesive and efficient workflows that seamlessly integrate with the FA process. This paper investigates the design and implementation of a Large Language Model (LLM)-based Planning Agent (LPA) to assist FA engineers in solving their analysis cases. The LPA integrates LLMs with advanced planning capabilities and external tool utilization, enabling autonomous processing of complex queries, retrieval of relevant data from external systems, and generation of human-readable responses. Evaluation results demonstrate the agents operational effectiveness and reliability in supporting FA tasks.',
    authors: [
      { name: 'Aline Dobrovsky', avatar: '/static/images/avatar/6.jpg' },
      { name: 'Konstantin Schekotihin', avatar: '/static/images/avatar/6.jpg' },
       { name: 'Christian Burmer', avatar: '/static/images/avatar/1.jpg' },
    ],
  },
 
];

const StyledTypography = styled(Typography)({
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 8,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});

const TitleTypography = styled(Typography)(({ theme }) => ({
  position: 'relative',
  textDecoration: 'none',
  '&:hover': { cursor: 'pointer' },
  '& .arrow': {
    visibility: 'hidden',
    position: 'absolute',
    right: 0,
    top: '50%',
    transform: 'translateY(-50%)',
  },
  '&:hover .arrow': {
    visibility: 'visible',
    opacity: 0.7,
  },
  '&:focus-visible': {
    outline: '3px solid',
    outlineColor: 'hsla(210, 98%, 48%, 0.5)',
    outlineOffset: '3px',
    borderRadius: '8px',
  },
  '&::before': {
    content: '""',
    position: 'absolute',
    width: 0,
    height: '1px',
    bottom: 0,
    left: 0,
    backgroundColor: (theme.vars || theme).palette.text.primary,
    opacity: 0.3,
    transition: 'width 0.3s ease, opacity 0.3s ease',
  },
  '&:hover::before': {
    width: '100%',
  },
}));

function Author({ authors}: { authors: { name: string; avatar: string }[] }) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        gap: 2,
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <Box
        sx={{ display: 'flex', flexDirection: 'row', gap: 1, alignItems: 'center' }}
      >
        <AvatarGroup max={3}>
          {authors.map((author, index) => (
            <Avatar
              key={index}
              alt={author.name}
              src={author.avatar}
              sx={{ width: 24, height: 24 }}
            />
          ))}
        </AvatarGroup>
        <Typography variant="caption">
          {authors.map((author) => author.name).join(', ')}
        </Typography>
      </Box>
    </Box>
  );
}

export default function Publications() {
  const [focusedCardIndex, setFocusedCardIndex] = React.useState<number | null>(
    null,
  );

  const handleFocus = (index: number) => {
    setFocusedCardIndex(index);
  };

  const handleBlur = () => {
    setFocusedCardIndex(null);
  };

  return (
    <div>
      <Typography variant="h2" gutterBottom>
        References/ Papers
      </Typography>
      <Grid container spacing={8} columns={12} sx={{ my: 4 }}>
        {articleInfo.map((article, index) => (
          <Grid key={index} size={{ xs: 12, sm: 6 }}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                gap: 1,
                height: '100%',
              }}
            >
              <Typography gutterBottom variant="caption" component="div">
                {article.tag}
              </Typography>
              <TitleTypography
                gutterBottom
                variant="h6"
                onFocus={() => handleFocus(index)}
                onBlur={handleBlur}
                tabIndex={0}
                className={focusedCardIndex === index ? 'Mui-focused' : ''}
              >
                <a target="_blank" href={article.link}>{article.title}</a>
                <NavigateNextRoundedIcon
                  className="arrow"
                  sx={{ fontSize: '1rem' }}
                />
              </TitleTypography>
              <StyledTypography variant="body2" color="text.secondary" gutterBottom>
                {article.description}
              </StyledTypography>
              <StyledTypography  variant="body2" color="text.secondary" gutterBottom>{article.date}</StyledTypography>
              <Author authors={article.authors} />
            </Box>
          </Grid>
        ))}
      </Grid>
     
    </div>
  );
}

/* <Box sx={{ display: 'flex', flexDirection: 'row', pt: 4 }}>
        <Pagination hidePrevButton hideNextButton count={10} boundaryCount={10} />
      </Box>
*/